import React, { useEffect, useState } from 'react';
import { formatDataHora } from '../utils/dreFormat';
import { IconClipboard } from './Icons';

// Plano de ação do mês (1 por escopo). Editável no PDCA próprio; somente leitura
// no drilldown. `onSave(descricao)` faz o upsert e retorna Promise.
function DrePlanoAcao({ planoAcao, editable, onSave }) {
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null); // { tipo: 'ok'|'erro', msg }

  useEffect(() => {
    setDraft((planoAcao && planoAcao.descricao) || '');
    setFeedback(null);
  }, [planoAcao]);

  const handleSave = async () => {
    const descricao = draft.trim();
    if (!descricao) {
      setFeedback({ tipo: 'erro', msg: 'Plano de ação vazio' });
      return;
    }
    setSaving(true);
    setFeedback(null);
    try {
      await onSave(descricao);
      setFeedback({ tipo: 'ok', msg: 'Salvo' });
    } catch (err) {
      setFeedback({ tipo: 'erro', msg: err.message || 'Erro ao salvar' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dre-plano">
      <div className="dre-card-header">
        <span className="dre-card-title"><IconClipboard size={20} /> Plano de Ação</span>
      </div>

      {editable ? (
        <>
          <textarea
            className="dre-just-input"
            value={draft}
            maxLength={5000}
            rows={5}
            placeholder="Descreva o plano de ação do mês..."
            onChange={e => setDraft(e.target.value)}
          />
          <div className="dre-just-actions">
            <button className="dre-save-button" disabled={saving} onClick={handleSave}>
              {saving ? 'Salvando...' : 'Salvar plano de ação'}
            </button>
            {feedback && <span className={`dre-feedback dre-feedback-${feedback.tipo}`}>{feedback.msg}</span>}
            {planoAcao && planoAcao.dataAtualizacao && (
              <span className="dre-just-meta">Atualizado em {formatDataHora(planoAcao.dataAtualizacao)}</span>
            )}
          </div>
        </>
      ) : (
        <p className="dre-just-readonly">
          {planoAcao && planoAcao.descricao ? planoAcao.descricao : <em>Sem plano de ação registrado.</em>}
        </p>
      )}
    </div>
  );
}

export default DrePlanoAcao;
